import { QueryFunctionContext, useQuery } from 'react-query';
import { assignment_api } from '@axo/shared/data-access/api';
import { useAPI } from '@axo/shared/data-access/provider';
import {
  assignmentKeys,
  parseAssignmentKey,
} from '../../cache-keys/assignmentKeys';
import { queryFunction } from '../../query-function';

function countUnprocessedQuery({
  queryKey,
}: QueryFunctionContext<
  ReturnType<(typeof assignmentKeys)['countUnprocessed']>
>) {
  const { marketCountry } = parseAssignmentKey(queryKey);
  return marketCountry;
}

export function useCountUnprocessed(
  marketCountry: string,
  options?: { enabled?: boolean }
) {
  const api = useAPI();
  const cacheKey = assignmentKeys.countUnprocessed({
    marketCountry,
  });
  return useQuery(
    cacheKey,
    queryFunction(
      assignment_api.countUnprocessedAssignments(api),
      countUnprocessedQuery
    ),
    {
      enabled: options?.enabled ?? true,
    }
  );
}
